import { PublicClientApplication } from "@azure/msal-browser";
import {
  MS_CLIENT_ID,
  MS_AUTHORITY_URL,
  MS_REDIRECT_URI,
  MS_REDIRECT_URI_LOCAL,
} from "../store/config";
import { redirect } from "react-router-dom";


export const msalConfig = {
  auth: {
    clientId: MS_CLIENT_ID,
    authority: MS_AUTHORITY_URL,
    redirectUri: MS_REDIRECT_URI,
    // redirectUri: MS_REDIRECT_URI_LOCAL,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};
 
export const msalInstance = new PublicClientApplication(msalConfig);